import { login as apiLogin, getUserInfo as apiGetUserInfo, loginWithCmccToken } from '../api/user'
import { getMockUserData } from '../api/mock'
import { STORAGE_KEYS } from './constants'
import { isCmccEnvironment, getCmccToken } from './bridge'
import { setAuthToken } from './http'

function loadStoredData(key, fallback) {
  try {
    var raw = localStorage.getItem(key)
    return raw ? JSON.parse(raw) : fallback
  } catch (e) {
    return fallback
  }
}

function saveToStorage(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify(data))
  } catch (e) {}
}

/**
 * 登录优先级：
 * 1) APP 环境 → 通过 JSBridge 拿 cmccToken → 后端换游戏中心 token/userId
 * 2) 后端匿名登录（deviceId + appKey）
 * 3) 本地缓存兜底
 */
export function initAuth() {
  return new Promise(function(resolve) {
    var chain = Promise.reject(new Error('start'))

    // 1) APP 内优先走 CMCC 桥
    if (isCmccEnvironment()) {
      chain = chain.catch(function() {
        return getCmccToken().then(function(t) {
          return loginWithCmccToken(t.token)
        })
      })
    }

    // 2) 匿名登录兜底
    chain = chain.catch(function() { return apiLogin() })

    chain.then(function(data) {
      if (data && data.token) setAuthToken(data.token)
      saveToStorage(STORAGE_KEYS.LOGIN_DATA, { userId: data.userId })
      resolve({ token: data.token || 'api', userId: data.userId, fromCache: false })
    }).catch(function() {
      // 3) 本地缓存兜底
      var cached = loadStoredData(STORAGE_KEYS.LOGIN_DATA)
      if (cached && cached.userId) {
        resolve({ token: 'cached', userId: cached.userId, fromCache: true })
      } else {
        resolve({ token: 'fallback', userId: null, fromCache: false })
      }
    })
  })
}

export function loadUserInfo(userId) {
  return new Promise(function(resolve) {
    if (!userId) {
      resolve(getMockUserData())
      return
    }
    // 优先从服务器获取最新用户信息
    apiGetUserInfo(userId).then(function(data) {
      var avatar = data.avatar || ''
      // 剥离协议+host，仅保留路径；并保证 /mygames 前缀存在（与 portal.js stripHost 对齐）
      if (avatar) {
        var m = /^https?:\/\/[^/]+(\/.*)?$/i.exec(avatar)
        if (m) avatar = m[1] || '/'
        if (avatar.charAt(0) === '/' && avatar.indexOf('/mygames') !== 0) {
          avatar = '/mygames' + avatar
        }
      }
      var userInfo = {
        userId: data.userId,
        nickname: data.nickname || '游戏玩家',
        avatar: avatar,
        username: data.username || '',
        registerTime: data.registerTime || '',
        level: 1,
        exp: 0,
        totalExp: 100,
        levelName: '青铜玩家',
        levelIcon: '🥉',
        gameRecordCount: 0,
        totalPlayTime: '0小时'
      }
      saveToStorage(STORAGE_KEYS.USER_INFO, userInfo)
      resolve(userInfo)
    }).catch(function() {
      // 服务器不通，用缓存兜底
      var cached = loadStoredData(STORAGE_KEYS.USER_INFO)
      if (cached) {
        resolve(cached)
      } else {
        var mock = getMockUserData()
        resolve(mock)
      }
    })
  })
}

export function setUserInfo(info) {
  saveToStorage(STORAGE_KEYS.USER_INFO, info)
}

export function getStoredUserInfo() {
  return loadStoredData(STORAGE_KEYS.USER_INFO)
}

export function clearAuth() {
  try {
    localStorage.removeItem(STORAGE_KEYS.LOGIN_DATA)
    localStorage.removeItem(STORAGE_KEYS.USER_INFO)
  } catch (e) {}
  setAuthToken('')
}
